import React from "react";
import "./Programs.scss";

const DATA = [
  { t: "Bērni 4+ gadi", d: "Spēles, koordinācija, tehnikas pamata un disciplīna." },
  { t: "K-1", d: "Kikboksa tehnika, lokanība, pamatspēks." },
  { t: "Muay Thai", d: "Funkcionālie treniņi, tehnika, sparingi." },
  { t: "MMA", d: "Kikboksa un Muay Thai tehnika, graplings, sparingi" },
  { t: "Strength & Mobility", d: "Funkcionālie treniņi, Mobilitate, koordinācija, lokaniba" },
];

export default function Programs() {
  return (
    <section id="programs" className="section">
      <div className="container">
        <header className="section__head">
          <h2>Programmas</h2>
          <p className="muted">TOP RING piedāvā nodarbības bērniem no 4 gadu vecuma, kurus vada pieredzējuši un sertificēti treneri — cilvēki, kuri ar sirdi dara savu darbu.</p>
        </header>
        <div className="cards">
          {DATA.map((p) => (
            <article key={p.t} className="card">
              <h3>{p.t}</h3>
              <p className="muted">{p.d}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
